import { useEffect, useState, useRef } from 'react';
import Swal from 'sweetalert2';

import { PaymentInformation, PaymentInformationWithDetails } from '../../classess/paymentInformation/paymentInformation';

import { GlobalFormats } from '../../classess/main/globalFormats';

import PaymentInformationAdd from './PaymentInformationAdd';
import {
    awaitDelayAsync, getProcessButtons, dataTableLanguaje, getDtRowIndex, isUndNull, isUndNullEmp, getLanguageObj,
    getResponse, handleResponseMessageAsync, settings, LoadingSection, styles
} from '../../helpers/main';
import { PaymentInformationService } from '../../services/paymentInformation/PaymentInformationService';
import useAuth from '../../auth/UseAuth';
import Menu from '../main/Menu';
import TableIndex from '../main/TableIndex';
import AccessDenied from '../main/AccessDenied';

const $ = window.jqGlobal || window.jQuery;

const { app, backend, html, colors, icons, images, labels, messages, timers } = settings;

const currentMethod = 'PaymentInformations';

export default function PaymentInformations({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const auth = useAuth();
    const isMount = useRef(true);
    const userRole = auth?.userRole({ languageId: languageObj?.id, subMethod: currentMethod })?.result || '';
    const dtPaymentInformationsId = 'dtPaymentInformations';
    const [showData, setShowData] = useState(true);
    const [process, setProcess] = useState({ showLoading: false, add: false, });
    const [paymentInformation, setPaymentInformation] = useState(PaymentInformation?.class({}, false));
    const [modalObj, setModalObj] = useState({
        $: $,
        type: 0,
        auth: auth,
        showModal: false,
        languageObj: languageObj,
        dtPaymentInformationsId: dtPaymentInformationsId,
        dtPaymentInformationsRowId: 0,
        userRole: userRole,
    });
    const controls = {
        buttons: {
            addEditDetails: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnAddEditDetails',
            },
        },
        icons: {
            addEditDetails: {
                id: 'iconAddEditDetails',
                defaultClass: icons?.fasFa?.plusCircle,
            },
        },
        spiners: {
            addEditDetails: {
                id: 'spAddEditDetails',
                defaultClass: '',
            }
        },
    };
    //#endregion variables

    //#region methods
    //#region paymentinformations
    const getAddPaymentnformation = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getAddPaymentnformation';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            setProcess(prev => ({ ...prev, showLoading: true, add: true }));

            setPaymentInformation(PaymentInformation?.class({}, false));
            await awaitDelayAsync({ delayTime: timers?.twoNanoSeconds });

            setModalObj(prev => ({
                ...prev,
                $: $,
                type: 0,
                auth: auth,
                showModal: true,
            }));
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false, add: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({ response, currentMethod, auth, setShowData, showDataValue: response?.isSuccess, languageId: languageObj?.id });
            }
        }
    }

    const getEditDetaiPaymentInformation = async ({
        e = {},
        type = 1,
        id = '',
        description = '',
        rowId = '',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getEditDetaiPaymentInformation';
        let response = getResponse({ type: 0 });
        try {
            setProcess(prev => ({ ...prev, showLoading: true }));
            await awaitDelayAsync({ delayTime: timers?.oneSecond });

            switch (type) {
                case 1:
                    window.location.href = `${backend?.urls?.paymentInformations}/${labels?.edit?.en?.toLowerCase()}/${id}`;
                    break
                default:
                    window.location.href = `${backend?.urls?.paymentInformations}/${labels?.details?.en?.toLowerCase()}/${id}`;
                    break;
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({ response, currentMethod, auth, setShowData, showDataValue: response?.isSuccess, languageId: languageObj?.id });
            }
        }
    }

    const deletePaymentInformation = async ({
        e = {},
        id = '',
        description = '',
        rowId = 0,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'deletePaymentInformation';
        try {
            e?.preventDefault?.();

            //#region show message
            const msgTextObj = {
                one: `${messages?.areYouShureDeleteThis?.[languageObj?.id]}`,
                two: `${labels?.paymentInformation?.[languageObj?.id]}: <b>${description}</b><br/>`,
                three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };

            const swalProperties = {
                icon: settings.react.sweetAlert2.messages.types.warning,
                title: msgTextObj?.one,
                html: `${msgTextObj?.two}${msgTextObj?.three}`,
                timer: null,
                confirmButtonColor: colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: !Swal.isLoading(),
                cancelButtonColor: colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                customClass: {
                    confirmButton: html?.buttons?.primary,
                    cancelButton: html?.buttons?.secondary,
                },
                allowOutsideClick: () => !Swal.isLoading(),
                preConfirm: async () => {
                    let preConfirmResponse = getResponse({ type: 0 });
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal.update({
                            icon: settings?.react?.sweetAlert2?.messages?.types?.info,
                            title: `${messages?.processingPleaseWait?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.two} `,
                            showConfirmButton: false,
                        });

                        preConfirmResponse = await PaymentInformationService.deleteAsync({
                            token: auth?.user?.token?.token,
                            id: id,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });

                        if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return preConfirmResponse;

                        $(`#${dtPaymentInformationsId}`)?.DataTable()?.row(rowId)?.remove()?.draw(true);

                        preConfirmResponse.msgText = messages?.processCompletedSuccessfully?.[languageObj?.id];
                    } catch (ex) {
                        preConfirmResponse = getResponse({ type: -1 });
                        preConfirmResponse.msgText = `Method: ${currentMethod}<br/>`;
                        preConfirmResponse.msgText += `Sub method: preConfirm (Swal)<br/>`;
                        preConfirmResponse.msgText += `Error: ${ex?.message}<br/>`;
                    }
                    return preConfirmResponse;
                },
            };

            const swalResult = await Swal.fire({ ...swalProperties });
            if (swalResult?.isConfirmed && swalResult?.value) {
                response = swalResult?.value;
            } else if (swalResult?.isDismissed) {
                response = getResponse({ type: 0 });
            }
            //#endregion show message
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({ response, currentMethod, auth, setShowData, showDataValue: response?.isSuccess, languageId: languageObj?.id });
            }
        }
    }
    //#endregion paymentinformations

    //#region others
    const getData = async ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            if (auth?.isLoged({ subMethod: currentMethod })?.result) {
                setProcess(prev => ({ ...prev, showLoading: true }));

                response = setDataTables({ subMethod: currentMethod });
                if (!response?.isSuccess || response?.isWarning) return;

                response = setQueryCode({ subMethod: currentMethod });
                if (!response?.isSuccess || response?.isWarning) return;

                response = await PaymentInformationService.getAllWithDetailsAsync({
                    token: auth?.user?.token?.token,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) return;

                const paymentInformations = response?.result?.paymentInformations || [];

                if (!isUndNullEmp({ data: paymentInformations, subMethod: currentMethod })?.result &&
                    paymentInformations.length > 0) {
                    response = setDataInDataTable({
                        data: paymentInformations,
                        subMethod: currentMethod,
                    });
                    if (!response?.isSuccess || response?.isWarning) return;
                }
            } else {
                setShowData(false);
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({ response, currentMethod, auth, setShowData, showDataValue: response?.isSuccess, languageId: languageObj?.id });
            }
        }
    }

    const setDataTables = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDataTables';
        let response = getResponse({ type: 0 });
        try {
            $(`#${dtPaymentInformationsId}`).DataTable({
                columns: [
                    { title: labels?.description?.[languageObj?.id], width: '55%', },
                    { title: labels?.logo?.[languageObj?.id], width: '25%', },
                    { title: labels?.accounts?.[languageObj?.id], className: 'text-right', width: '15%', },
                    { title: labels?.process[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                order: [[0, 'asc']],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setQueryCode';
        let response = getResponse({ type: 0 });
        try {
            $(`#${dtPaymentInformationsId} tbody`).on('click', 'tr', 'td', async function (e) {
                const rowId = getDtRowIndex({ dtId: dtPaymentInformationsId, _this: this, subMethod: currentMethod, })?.result;
                if (!isUndNull({ data: rowId, subMethod: currentMethod })?.result) {
                    const methodName = e?.target?.attributes?.method?.value || '';
                    const id_ = e?.target?.attributes?.id?.value || '';
                    const description = e?.target?.attributes?.description?.value || '';

                    switch (methodName) {
                        case 'edit':
                            getEditDetaiPaymentInformation({
                                e: e,
                                type: 1,
                                id: id_,
                                description: description,
                                rowId: rowId,
                                subMethod: currentMethod,
                            });
                            break;
                        case 'details':
                            getEditDetaiPaymentInformation({
                                e: e,
                                type: 2,
                                id: id_,
                                description: description,
                                rowId: rowId,
                                subMethod: currentMethod,
                            });
                            break;
                        case 'delete':
                            deletePaymentInformation({
                                e: e,
                                id: id_,
                                description: description,
                                rowId: rowId,
                                subMethod: currentMethod,
                            });
                            break;
                        default:
                            break;
                    }
                }
            });
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDataInDataTable = ({
        data = [],
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDataInDataTable';
        let response = getResponse({ type: 0 });
        try {
            let paymentInformationsDt = [];

            data.forEach((paymentInfo) => {
                const modelPaymentInformationWithDetails = PaymentInformationWithDetails.class(paymentInfo, false);
                let logoUrl = modelPaymentInformationWithDetails?.logo || '';
                if (!isUndNullEmp({ data: logoUrl, subMethod: currentMethod })?.result) {
                    logoUrl = logoUrl.replace('~/Images/Logos/PaymentInformation/', `${backend?.urls?.imageLogos}${backend?.urls?.paymentInformations}/`);
                    logoUrl = `${backend?.urls?.api}${logoUrl}`;
                } else {
                    logoUrl = `${backend?.urls?.api}${images?.noImage}`;
                }
                const logo = `<img alt='paymentLogo' src='${logoUrl}' height='auto' width='60px'/>`;

                const processButtons = [];

                paymentInformationsDt.push([
                    modelPaymentInformationWithDetails.name,
                    logo,
                    modelPaymentInformationWithDetails?.accounts?.length || 0,
                    getProcessButtons({
                        id: modelPaymentInformationWithDetails.id,
                        description: modelPaymentInformationWithDetails.name,
                        showDetails: true,
                        labelDetails: labels?.details[languageObj?.id],
                        enabledDetails: true,
                        showDelete: userRole === settings?.roles?.admin,
                        labelDelete: labels?.delete[languageObj?.id],
                        enabledDelete: userRole === settings?.roles?.admin,
                        showEdit: userRole === settings?.roles?.admin,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: userRole === settings?.roles?.admin,
                        processButtons: processButtons,
                    })?.result,
                ]);
            });

            $(`#${dtPaymentInformationsId}`)?.DataTable()?.rows?.add(paymentInformationsDt)?.draw(true);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => {
            isMount.current = false;
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods

    return (
        <div>
            <Menu viewName={app?.views?.paymentInformations?.paymentInformations} process={app?.views?.paymentInformations?.paymentInformations} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>

                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.paymentInformations?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href='/'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.paymentInformations?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {auth?.isLoged({ subMethod: currentMethod })?.result ? (
                            <div className='row'>
                                <div className='col-12'>
                                    {showData ? (
                                        <div className={html?.cards?.default} style={{ borderRadius: '10px' }}>
                                            <LoadingSection alt='loadingSection'
                                                className='overlay dark text-white'
                                                height={20}
                                                hidden={!process?.showLoading}
                                                width={20}
                                                languageId={languageObj?.id}
                                                subMethod={currentMethod} />

                                            <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                <div className='d-flex align-items-center'>
                                                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <img alt={labels?.paymentInformation?.[languageObj?.id]} src={images?.icons?.paymentInformation} style={styles?.cardHeaderLogo} />
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <h5 className='mb-0 font-weight-bold text-dark'>{labels?.paymentInformation?.[languageObj?.id]}</h5>
                                                        <div className='mt-1'>
                                                            <span className='badge badge-pill badge-info px-2 py-1 text-uppercase' style={html?.badges?.micro}>
                                                                <i className={`${icons?.fasFa?.creditCard} mr-1`}></i> {labels?.index?.[languageObj?.id]}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className='ml-auto'>
                                                        <button id={controls?.buttons?.addEditDetails?.id}
                                                            type='button'
                                                            className={controls?.buttons?.addEditDetails?.defaultClass}
                                                            disabled={process?.add}
                                                            title={labels?.add?.[languageObj?.id]}
                                                            onClick={(e) => getAddPaymentnformation({ e: e, subMethod: controls?.buttons?.addEditDetails?.id })}
                                                            style={{ borderRadius: '5px' }}>
                                                            {process?.add ? (
                                                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                            ) : (
                                                                <i id={controls?.icons?.addEditDetails?.id} className={controls?.icons?.addEditDetails?.defaultClass} />
                                                            )} {labels?.add?.[languageObj?.id]}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='card-body px-4 pb-4'>
                                                <TableIndex tableId={dtPaymentInformationsId} languageObj={languageObj} />
                                            </div>
                                        </div>
                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <AccessDenied languageObj={languageObj} />
                        )}

                    </div>
                </section>
                {/* Main content */}
            </div>

            {(modalObj?.showModal &&
                <PaymentInformationAdd
                    modalObj={modalObj}
                    setModalObj={setModalObj}
                    paymentInformation={paymentInformation}
                    setPaymentInformation={setPaymentInformation} />
            )}
        </div>
    )
}